export const ACCOUNT_SET_TYPE_LABELS = {
  0: '生产进销存账',
  1: '收银进销存账',
  2: '云ERP账',
  9: '总部一套账'
};

export const CREATABLE_ACCOUNT_SET_TYPES = [1, 2, 9];

export function formatAccountSetType (accountSetType) {
  if (accountSetType === undefined || accountSetType === null || accountSetType === '') {
    return '--';
  }
  return ACCOUNT_SET_TYPE_LABELS[Number(accountSetType)] || '--';
}
